// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { GoogleMap, InfoWindow, Marker } from "@react-google-maps/api";
import * as React from "react";
import { connect } from "react-redux";

export interface HasDynamicGoogleMaps {
    useLoadScript: ({ googleMapsApiKey }: { googleMapsApiKey: any }) => { isLoaded: boolean };
    GoogleMap: GoogleMap;
    InfoWindow: InfoWindow;
    Marker: Marker;
}

export default function XngWithDynamicGoogleMaps(Component: React.ComponentType<any>) {
    return function passPropsOn(props: any) {
        return <ImportGoogleMapsConnected {...props} component={Component} />;
    };
}

class ImportGoogleMaps extends React.Component {
    state = {
        useLoadScript: () => ({ isLoaded: false }),
        GoogleMap: null,
        InfoWindow: null,
        Marker: null,
        // XNG-Changes
        Autocomplete: null,
    };

    // XNG-CHANGES SAINC-1353 : Adding Autocomplete to @react-google-maps/api by overriding the original file (withDynamicGoogleMaps.tsx)
    componentDidMount() {
        if ((this.props as any).disableGoogleScriptsInclusion) {
            return;
        }

        import(/* webpackChunkName: "googleMapsApi" */ "@react-google-maps/api").then(
            ({ useLoadScript, GoogleMap, InfoWindow, Marker, Autocomplete }) => {
                this.setState({
                    useLoadScript,
                    GoogleMap,
                    InfoWindow,
                    Marker,
                    // XNG-Changes
                    Autocomplete,
                });
            },
        );
    }

    render() {
        const { component: Component, disableGoogleScriptsInclusion } = this.props as any;
        if (
            !disableGoogleScriptsInclusion &&
            (!this.state.useLoadScript ||
                !this.state.GoogleMap ||
                !this.state.InfoWindow ||
                !this.state.Marker ||
                // XNG-Changes
                !this.state.Autocomplete)
        ) {
            return null;
        }

        return <Component {...this.props} {...this.state} />;
    }
}

const mapStateToProps = (state: ApplicationState) => ({
    disableGoogleScriptsInclusion: getSettingsCollection(state).websiteSettings.disableGoogleScriptsInclusion,
});

const ImportGoogleMapsConnected = connect(mapStateToProps)(ImportGoogleMaps);
